import React from 'react';
import { Row, Col ,Input } from 'antd';

class Search extends React.Component {
  constructor(props) {
      //父组件传入参数
      super(props);    
      //当前组件状态
      this.state = {    
		searchContent:"",
      }
  };
	// 保存搜索内容
	changeSearchInput = (e) =>{
		this.setState({searchContent:e.target.value})
	}
	// 发起搜索
	requestSearch = (e) =>{
		window.location.href =`https://app.moxidata.cn/moximerchants/moxiSearchresult?strwords=${this.state.searchContent}&page=1`
		this.setState({searchContent:""})
	}

    render(){
		let dynamicText = `我们愿和森林一样，由苗成树，由树成林，并构建有“营养”的产业链生态园$
		我们正努力尝试着伸手触摸森林边界、探究行业深度；所以，$
		不论你是苇草，还是大树，都让我们携手共生共荣，一起向阳成长……`;

		let JSXDynamicText =[];

		for(let i=0;i<dynamicText.length;i++){
			if(dynamicText[i] === "$"){
				JSXDynamicText.push(<div key={i}></div>)
			}else{
				JSXDynamicText.push(<span className='word-item' key={"word"+i} style={{animationDelay:(i*0.1+0.4)+"s"}}>{dynamicText[i]}</span>)
			}
		}
        return(
            <Row justify="center" align="middle" className="search-div">
				<Col span={10}>
					<div className="search-body">
						<Input className="search-input" placeholder="输入并搜索" bordered={false} onChange={this.changeSearchInput} onPressEnter={this.requestSearch}/>
						<div className="search-function" onClick={this.requestSearch}><img className="search-icon" alt="" src='/forest/image/search.png' /></div>
					</div>
				</Col>
				<div className='dynamicText-body'>
					{JSXDynamicText}
				</div>
			</Row>
        );
    }  
}

export default Search;